export const DEPENDENCIES_BY_TYPE = {
  INSTITUTIONAL: 'institutional',
  FACULTY: 'faculty',
  FACULTY_SEDE_ACADEMIC: 'facultyAndSedeAndAcademic',
  CAREER: 'career',
  ADMINISTRATIVE: 'administrative',
  SEDE: 'sede',
};

export const ROLES = {
  CIMOGSYS: 'Cimogsys',
  RECTOR: 'Rector',
  VICERRECTOR:'Vicerrector',
  DIRECTOR_IDI: 'Director IDI',
  DECANO: 'Decano',
  SUBDECANO: 'Subdecano',
  INVESTIGADOR: 'Investigador',
  ADMIN_GROUPS: 'Admin groups',
  ADMIN_PROJECTS: 'Admin projects',
  GUEST_GROUPS: 'Invitado Grupos',
  GUEST_PROJECTS: 'Invitado Proyectos',
};

export const SEX = {
  HOMBRE: 'Hombre',
  MUJER: 'Mujer',
};

export const Estudents = [
  { id: 14, name: 'INVESTIGADOR ESTUDIANTE REGULAR' },
  { id: 15, name: 'INVESTIGADOR PRACTICANTE' },
  { id: 16, name: 'INVESTIGADOR PASANTE' },
  { id: 17, name: 'INVESTIGADOR AYUDANTE DE INVESTIGACIÓN' },
  { id: 18, name: 'INVESTIGADOR TESISTA DE GRADO' },
  { id: 19, name: 'INVESTIGADOR TESISTA POSGRADO' },
];

export const levels = {
  JUNIOR: 'JUNIOR',
  SENIOR: 'SENIOR',
  NO_ASIGNADO: 'NO ASIGNADO',
};

export const typesRequirements = {
  BIEN: 'BIEN',
  OBRA: 'OBRA',
  SERVICIO: 'SERVICIO',
  CONSULTORIA: 'CONSULTORIA',
};

export const typesIva = {
  DOCE: 'IVA 12%',
  CERO: 'IVA 0%',
};

export const typesCuatrimestre = {
  PRIMER: 'I',
  SEGUNDO: 'II',
  TERCERO: 'III',
};

export const coverageTypes = {
  INTERNACIONAL: { id: 1, name: 'INTERNACIONAL' },
  NACIONAL: { id: 2, name: 'NACIONAL' },
  REGIONAL: { id: 3, name: 'REGIONAL' },
  PROVINCIAL: { id: 4, name: 'PROVINCIAL' },
  CANTONAL: { id: 5, name: 'CANTONAL' },
  PARROQUIAL: { id: 6, name: 'PARROQUIAL' },
};

export const years = ['2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017'];

export const months = [
  { id: 1, name: 'Enero' },
  { id: 2, name: 'Febrero' },
  { id: 3, name: 'Marzo' },
  { id: 4, name: 'Abril' },
  { id: 5, name: 'Mayo' },
  { id: 6, name: 'Junio' },
  { id: 7, name: 'Julio' },
  { id: 8, name: 'Agosto' },
  { id: 9, name: 'Septiembre' },
  { id: 10, name: 'Octubre' },
  { id: 11, name: 'Noviembre' },
  { id: 12, name: 'Diciembre' },
];

export const formatDate = {
  DATE: 'yyyy/MM/dd',
};

export const statuses = [
  { id: 1, name: 'PENDIENTE' },
  { id: 2, name: 'NO COMPRADO' },
  { id: 3, name: 'PAGADO' },
  { id: 4, name: 'ENTREGADO' },
];

export const publicationTypes = [
  { id: 1, name: 'REVISTAS NACIONALES INDEXADAS' },
  { id: 2, name: 'REVISTAS INTERNACIONALES INDEXADAS' },
  { id: 3, name: 'REVISTAS NACIONALES' },
  { id: 4, name: 'MEMORIAS' },
  { id: 5, name: 'LIBROS REVISADOS POR PARES Y CON ISBN' },
  { id: 6, name: 'CONGRESOS NACIONALES/INTERNACIONALES' },
];

export const thesisTypes = [
  { id: 1, name: 'PREGRADO' },
  { id: 2, name: 'POSTGRADO' },
];

export const thesisStatus = [
  { id: 1, name: 'PLAN APROBADO' },
  { id: 2, name: 'EN EJECUCIÓN' },
  { id: 3, name: 'TERMINADO' },
];

export const typeReport = { 
  ORIGINAL: 'ORIGINAL', 
  SUSTITUTIVO: 'SUSTITUTIVO' 
};

export default {
  DEPENDENCIES_BY_TYPE,
  ROLES,
  SEX,
  levels,
  typesRequirements,
  coverageTypes,
  formatDate,
  years,
  months,
  statuses,
  publicationTypes,
  thesisTypes,
  thesisStatus,
  typeReport,
  Estudents,
};
